import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(public)/[slug]/error.tsx");
